<template>
    <div>
        <div v-if="coupons.length > 0" class="border border-green-500 text-green-500 text-center w-full bg-green-100 rounded p-2 mb-5">Du har <b>{{ coupons.length }} st</b> tillgodohavanden som kommer användas vid bokning.</div>
        <div v-else-if="coupons.length <= 0 && showWarning" class="border border-red-500 text-red-500 text-center w-full bg-red-100 rounded p-2 mb-5">Du saknar tillgodohavanden för att boka vald behandling. Du måste först göra ett köp hos Benify.</div>
    </div>
</template>

<script>
export default {
    name: "CouponInfo",
    props: ['coupons', 'showWarning'],
}
</script>

<style scoped>

</style>
